import * as Collections from 'typescript-collections';
import {
  EntityCodes,
  FilterTypes,
  LocationTypes,
  NodeSortDirection,
  PageRights,
} from './global-enums';

export type Optional<T> = T | null;

export class GenericMaster<T = number> {
  public Id: T;
  public Name: string;
}

export class GenericMasterWithCount<U> extends GenericMaster<U> {
  public Id: U;
  public Count: number;
}

export class GenericMasterString extends GenericMaster<string> {
  public Id: string;
  public Name: string;
}

export class GenericPropertyMaster<T> {
  public Id: T;
  public Name: string;
  public PropertyId?: number;
  public PropertyCode: string;
}

export class TypedPriorityMaster {
  public Id: Number;
  public Name: string;
}

export class TypedGenericMaster<T, U> extends GenericMaster<T> {
  public Type: U;
}

export class TypedGenericPropertyMaster<T, U> extends GenericPropertyMaster<T> {
  public Type: U;
}

export type TypedDescMaster = TypedGenericPropertyMaster<number, 'wo' | 'job'>;

// export class TypeSearch {
//   public EntityCode: EntityCodes;
//   public Description: string;
// }

export interface Selectable {
  selected?: boolean;
}

export type SelectableGenericMaster<T> = GenericMaster<T> & Selectable;

export interface Position {
  top: number;
  left: number;
}

export interface Size {
  width: number;
  height: number;
}
export class LocationLookup {
  public Id: number;
  public ZoneId: number;
  public Description: string;
  public LocationTypeCode: LocationTypes;
  public Sections: Array<number> = [];
}

export class SectionLookup {
  public DeptId: number;
  public Id: number;
  public Name: string;
}

export class JobCategoryLookup {
  public Description: string;
  public Id: number;
  public IsKMTCategory?: boolean;
  public SkillId: number;
}

export class JobDescriptionLookup {
  public CategoryId: number;
  public ComplainType: number;
  public Description: string;
  public Id: number;
  public IsDel: boolean;
  public Priority: number;
}

export class SkillLookup {
  public Id: number;
  public Name: string;
  public DeptId: number;
}
export class LanguageLookup {
  public Language: string;
  public LanguageCode: string;
}

export class PropertyMasterTransform {
  public Key: string;

  public Location = new Collections.Dictionary<string, string>();

  public Staff = new Collections.Dictionary<string, string>();
  // public Reason = new Collections.Dictionary<string, string>();
  public Dept = new Collections.Dictionary<string, string>();
  // public DeviceType = new Collections.Dictionary<string, string>();
  public ComplainStatus = new Collections.Dictionary<string, string>();
  public Desg = new Collections.Dictionary<string, string>();
  // public Sections = new Collections.Dictionary<string, string>();
  public Skill = new Collections.Dictionary<string, string>();

  public Language = new Collections.Dictionary<string, string>();
  // public Groups = new Collections.Dictionary<string, string>();
  // public ComplainTypes = new Collections.Dictionary<string, string>();
  // public VIPs = new Collections.Dictionary<string, string>();
  // public EventMaster = new Collections.Dictionary<string, string>();

  public PropertyID: number;
  // public LanguageCode: string;
  // public LastUpdate: Date;
  // public LastUpdate_String: string;
}

export class PropertyMaster {
  public Key: string;

  public Location: Array<LocationLookup> = [];
  public Sections: Array<SectionLookup> = [];

  public CallCategories: Array<JobCategoryLookup> = [];
  public CallDescriptions: Array<JobDescriptionLookup> = [];
  public Staff: Array<GenericMaster> = [];
  // public Reason: Array<ReasonLookup> = [];
  public Dept: Array<GenericMaster> = [];
  // public DeviceType: Array<GenericMaster> = [];
  public ComplainStatus: Array<GenericMaster> = [];
  public Desg: Array<GenericMaster> = [];
  // public Sections: Array<SkillLookup> = [];
  public Skill: Array<SkillLookup> = [];

  public Language: Array<LanguageLookup> = [];
  // public Groups: Array<GenericMaster> = [];
  // public ComplainTypes: Array<GenericMaster> = [];
  // public VIPs: Array<VIP> = [];
  // public EventMaster: Array<GenericMaster> = [];

  public PropertyID: number;
  public LanguageCode: string;
  // public LastUpdate: Date;
  // public LastUpdate_String: string;
  // public Group: Array<GenericMaster> = [];

  public TransformedObjects = new PropertyMasterTransform();
}

export class PropertyBasicInfo {
  public PropertyId: number;
  public ChainId: number;
  public PropertyCode: string;
  public PropertyName: string;
  public TimeZoneId: number;
  public BaseUtcOffset: number;
  public PropertyDateFormat: string;
  public PropertyTimeFormat: string;
  public CurrencyName: string;
  public CurrencySymbol: string;
}

export class KMTAssetActionItems {
  items: string[] = [ActionsList.DELETE, ActionsList.PRINT];
}
export class KMTPMActionItems {
  items: string[] = [
    ActionsList.DELETE,
    ActionsList.ACTIVATE,
    ActionsList.DEACTIVATE,
  ];
}

export class KMTPMCalanderActionItems {
  items: string[] = [ActionsList.ACCEPT, ActionsList.REJECT];
}

export class KMTWOActionItems {
  items: string[] = [
    ActionsList.ASSIGN,
    ActionsList.PARK,
    ActionsList.CREATE,
    ActionsList.CANCEL,
  ];
}
export enum ActionsList {
  DELETE = 'DELETE',
  PRINT = 'PRINT',
  CREATE = 'CREATE',
  ASSIGN = 'ASSIGN',
  PARK = 'PARK',
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  CANCEL = 'CANCEL',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
}
export class PropertyMainMastersHelper {
  public TransformToLookup(
    Master: Collections.Dictionary<number, PropertyMaster>,
  ): void {
    const keys = Master.keys();

    for (let i = 0; i < keys.length; i++) {
      const row = Master.getValue(keys[i]);

      const ret = new PropertyMasterTransform();

      ret.Location = this.Transform_Id_Description(row.Location);
      ret.Staff = this.TransformGenericMaster(row.Staff);
      // ret.Reason = this.TransformReasonLookup(row.Reason);
      ret.ComplainStatus = this.TransformGenericMaster(row.ComplainStatus);
      ret.Dept = this.TransformGenericMaster(row.Dept);
      ret.Desg = this.TransformGenericMaster(row.Desg);
      // ret.DeviceType = this.TransformGenericMaster(row.DeviceType);
      // ret.Sections = this.TransformGenericMaster(row.Sections);
      ret.Skill = this.TransformGenericMaster(row.Skill);

      ret.Language = this.TransformLanguageLookup(row.Language);
      // ret.Groups = this.TransformGenericMaster(row.Groups);
      // ret.ComplainTypes = this.TransformGenericMaster(row.ComplainTypes);
      // ret.VIPs = this.Transform_Id_Description(row.VIPs);
      // ret.EventMaster = this.TransformGenericMaster(row.EventMaster);

      row.TransformedObjects = ret;
    }
  }

  public TransformLanguageLookup(
    lst: Array<LanguageLookup>,
  ): Collections.Dictionary<string, string> {
    let ret = new Collections.Dictionary<string, string>();
    if (lst == null) return ret;

    for (let i = 0; i < lst.length; i++) {
      let row = lst[i];
      ret.setValue(row.LanguageCode, row.Language);
    }

    return ret;
  }

  public Transform_Id_Description(
    lst: Array<any>,
  ): Collections.Dictionary<string, string> {
    const ret = new Collections.Dictionary<string, string>();
    if (lst === null) {
      return ret;
    }

    for (let i = 0; i < lst.length; i++) {
      const row = lst[i];
      ret.setValue(row.Id.toString(), row.Description);
    }

    return ret;
  }

  public TransformGenericMaster(
    lst: Array<GenericMaster>,
  ): Collections.Dictionary<string, string> {
    const ret = new Collections.Dictionary<string, string>();
    if (lst == null) {
      return ret;
    }

    for (let i = 0; i < lst.length; i++) {
      const row = lst[i];
      ret.setValue(row.Id.toString(), row.Name);
    }

    return ret;
  }

  public GetMasterValue(
    master: Collections.Dictionary<number, PropertyMaster>,
    PropertyId: number,
    ID: any,
    EntityCode: any,
    CurrentValue: any,
  ): any {
    if (ID == null) {
      return CurrentValue;
    }

    const obj = master.getValue(+PropertyId);
    if (obj == null) {
      return CurrentValue;
    }

    if (obj.TransformedObjects.hasOwnProperty(EntityCode) === false) {
      return CurrentValue;
    }

    const lst: Collections.Dictionary<string, string> =
      obj.TransformedObjects[EntityCode];

    ID = ID.toString();

    if (lst.containsKey(ID) === false) {
      return CurrentValue;
    }

    return lst.getValue(ID);
  }
}

export class PropertyAppFeatures {
  AdvanceSecurity: boolean; //"0"
  WebAuthExpiry: boolean; //"1"
  CheckOutDaysLimit: number; //"1"
  PreArrivalDaysLimit: number; //"8"
  MINIBAR_VOID_ALLOWED: boolean; //"TRUE"
  MINIBAR_VOID_DURATION_SECS: number; //"86400"
  MinibarHopTime: number; //"5"
  MinibarSameRoomRepostTime: number; //"1"
  MinibarShowRepostAlert: boolean; //"TRUE"
  MinibarShowSeekBar: boolean; //"TRUE"
  MinibarTotalSeekTime: number; //"30"
}

export class StaffBasicInfo {
  public StaffId: number;
  public LName: string;
  public FName: string;
  public DepartmentId: number;
  public Department: string;
  public DesignationId: number;
  public Designation: string;
  public Properties: Array<PropertyBasicInfo>;
  public ChainId: number;
  public PropertyId: number;
  public LanguageCode: string;
  public DeviceType: string;
  public DeviceId: string;
  public IsPropertyAdmin: boolean;
  public HasImage: boolean;
  public PropertyAuthorizations: Array<PropertyAuthorization> = [];
  public Settings: string;
  // public LicensedDevices: Array<LicensedDevices>;
  // public QuickCall: Array<QuickCallConfig>;
  public IsServiceStaff: boolean;
  public IsAlertPopupAudioEnabled: boolean;
  // public Licence: Array<ExpiredLicence>;
  public ActiveLicences: Array<ActiveLicences>;
  public AppFeatures: Record<number, PropertyAppFeatures>;
  public IsAdminUser = false;
}

export class ActiveLicences {
  public PropertyId: number;
  public MODULE_CODE: string;
  public RoleModule: string;
}

export class PropertyAuthorization {
  public PropertyId: number;
  public DeptId: number;
  public ModuleCode: string;
  public ActionCode: string;
  public IsAllowed: boolean;
}

export class Filter {
  public Locations: Array<number>;
  public Properties: Array<number>;
  public MetricTypes: Array<number>;
  public Metrics: Array<number>;
  public AssetCategories: Array<number>;
  public Keyword: string;

  setDefault(enableFilter: FilterTypes[]) {
    enableFilter.forEach((filter) => {
      switch (filter) {
        case FilterTypes.Locations:
          this.Locations = [];
          break;
        case FilterTypes.MetricTypes:
          this.MetricTypes = [];
          break;
        case FilterTypes.Metrics:
          this.Metrics = [];
          break;
        case FilterTypes.Properties:
          this.Properties = [];
          break;
        case FilterTypes.AssetCategories:
          this.AssetCategories = [];
          break;
      }
    });
    this.Keyword = '';
  }
}

export class ActionPayload<T, U = string> {
  Action: U;
  Entity: T;
}

export class FileAsset {
  public FileAssetId: number;
  public FileName: string;
  public AttachmentType: string;
  public TransactionId?: number;
  public DisplayFileName?: string;
  public Extension?: string;
}

export class NodeFileAssetRequest {
  attachmentName: string;
  attachmentLocation: string;
  attachmentExtension: string;
  attachmentSize: string;
  attachmentType: string;
  attachmentId?: number;
}

export interface ExcelDataServiceDelegate {
  shouldFetchMoreData(): boolean;
  fetchNextData();
  appendData();
  getFormattedHeader();
  getFormattedDataRow();
  download(name: string);
}

export interface ExcelDialogData {
  apiRequest;
  apiPageOptions;
  reportName: string;
  reportColumns;
  apiServiceDelegate: ExcelDataServiceDelegate;
}

export interface NodeSortOrder {
  field: string;
  dir: NodeSortDirection;
}

/** default implementation is for node apis,
 * for dotnet apis use KMTDotnetPaginatorDataSource
 */
export class KMTPaginatorDataSource {
  /** total records */
  length = 0;
  /** page size or limit */
  pageSize = 25;
  /** current page index */
  constructor(public pageIndex = 0) {}

  public get pageIndexDisplay(): number {
    return this.pageIndex;
  }

  reset() {
    this.length = 0;
    this.pageIndex = 0;
  }

  static fromNode(request, response) {
    request = request || {};
    response = response || {};
    const length = response.TotalRecords || 0;
    const pageSize = request.limit || 25;
    const offset = request.offset || 0;
    const pageIndex = pageSize ? offset / pageSize : 0;
    return Object.assign(new KMTPaginatorDataSource(), {
      length,
      pageSize,
      pageIndex,
    });
  }

  getNextOffset(nextPageIndex: number) {
    const offset = nextPageIndex * this.pageSize;
    return offset > this.length ? (nextPageIndex - 1) * this.pageSize : offset;
  }
}

export class KMTDotnetPaginatorDataSource extends KMTPaginatorDataSource {
  static fromDotNet(request, response): KMTDotnetPaginatorDataSource {
    request = request || {};
    response = response || {};
    const length = response.TotalRecords || 0;
    const pageSize = request.PageSize || 25;
    const pageIndex = request.PageNumber || 1;
    return Object.assign(new KMTDotnetPaginatorDataSource(pageIndex), {
      length,
      pageSize,
    });
  }

  constructor(public pageIndex = 1) {
    super(pageIndex);
  }

  reset() {
    this.pageIndex = 1;
    this.length = 0;
  }

  getNextOffset(nextPageIndex: number) {
    return nextPageIndex;
  }

  get pageIndexDisplay(): number {
    return this.pageIndex - 1;
  }
}

export class AssetDocTypes {
  public Id: string;
  public Description: string;
}

export interface MultipleRightsCheck {
  right?: PageRights;
  actionCode: string;
  checker: (queryParam: any) => boolean;
}
